export function isAppStorageInfo(data) {
    return (typeof data === "object" &&
        data !== null &&
        "size" in data &&
        typeof data.size === "number" &&
        "dataVersion" in data &&
        typeof data.dataVersion === "string" &&
        "hasSettings" in data &&
        typeof data.hasSettings === "boolean" &&
        "hasData" in data &&
        typeof data.hasData === "boolean" &&
        "hash" in data &&
        typeof data.hash === "string");
}
//# sourceMappingURL=AppStorageInfo.js.map